import { makeAutoObservable } from "mobx";
import { ContentItem, ImageParam, TabItems, CardItem } from "../types/privilege";
import { cutZero, numberFormat } from "@/utilities/number";

const initialTabList = [
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false, // 每个卡片都有
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    contentList: [],
    activeContentKey: 0,
  },
  {
    tabType: 0,
    tabLabel: "",
    targetUrl: "",
    darkTheme: false,
    title: "",
    titleTargetUrl: "",
    description: "",
    descriptionTargetUrl: "",
    subTitles: [],
    activeSubTitleKey: 0,
    introduce: "",
    introduceTargetUrl: "",
    introDespcription: "",
    introDespcriptionTargetUrl: "",
    introButtons: [],
    activeButtonKey: 0,
    introImageUrl: "", // 介绍图片
    introImageTargetUrl: "", // 介绍图片链接
  },
];
export default class PrivilegeStore {
  // 超级品专数据
  activeKey = 0;
  tabList: string;
  cardTypeList: string;
  // 霸屏数据
  fullScreenData: string;
  constructor () {
    /**
     * state
     */
    this.activeKey = 0;
    this.tabList = JSON.stringify(initialTabList);
    this.cardTypeList = JSON.stringify([]);
    this.fullScreenData = JSON.stringify({
      extraTemplateType: "", // 1: GIF首帧图，2: 图片
      duration: "", // 时长
      targetLink: "", // 跳转地址
      videoUrl: "", // 视频地址
      imageUrl: "", // 视频ID
    });
    makeAutoObservable(this);
  }

  get tabListData () {
    return JSON.parse(this.tabList) as TabItems[];
  }

  get typeList () {
    return JSON.parse(this.cardTypeList) || [];
  }

  get submitTabListData () {
    const listData = JSON.parse(this.tabList) as TabItems[] || [];
    const handleList = listData.map((item) => {
      const {
        tabType,
        tabLabel,
        targetUrl,
        contentList = [],
        darkTheme = false,
        // introduce1
        title,
        titleTargetUrl,
        description,
        descriptionTargetUrl,
        subTitles = [],
        introduce = "",
        introduceTargetUrl = "",
        introDespcription = "",
        introDespcriptionTargetUrl = "",
        introButtons = [],
        introImageUrl = "",
        introImageId,
        introImageWidth,
        introImageHeight,
        introImageTargetUrl = "",
      } = item;
      const handleFunctions = [
        () => {
          let contentDefaultUrlList: string[] = [];
          let contentTexts: string[] = [];
          let contentUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          contentList?.forEach((cItem: ContentItem) => {
            const {
              targetUrl = "",
              imageUrl,
              imageId,
              imageWidth,
              imageHeight,
              imageTargetUrl,
              title,
              titleTargetUrl,
              currency,
              description,
              descriptionTargetUrl,
              button,
              buttonTargetUrl
            } = cItem;
            contentDefaultUrlList.push(targetUrl || item.targetUrl);
            Array.prototype.push.apply(contentTexts, [title, `${currency}${description}`, button]);
            Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl, buttonTargetUrl]);
            contentImageList.push({
              imageUrl,
              id: imageId,
              width: imageWidth,
              height: imageHeight,
              targetUrl: imageTargetUrl,
            });
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentTexts,
            contentUrlList,
            contentImageList,
          };
        },
        () => {
          let contentDefaultUrlList: string[] = [];
          let contentTexts: string[] = [];
          let contentUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          contentList?.forEach((cItem: ContentItem) => {
            const {
              targetUrl = "",
              imageUrl,
              imageId,
              imageWidth,
              imageHeight,
              imageTargetUrl,
              title,
              titleTargetUrl,
              description,
              descriptionTargetUrl,
              button,
              buttonTargetUrl
            } = cItem;
            contentDefaultUrlList.push(targetUrl || item.targetUrl);
            Array.prototype.push.apply(contentTexts, [title, description, button]);
            Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl, buttonTargetUrl]);
            contentImageList.push({
              imageUrl,
              id: imageId,
              width: imageWidth,
              height: imageHeight,
              targetUrl: imageTargetUrl,
            });
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentTexts,
            contentUrlList,
            contentImageList,
          };
        },
        () => {
          let contentDefaultUrlList: string[] = [];
          let contentTexts: string[] = [];
          let contentUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          contentList?.forEach((cItem: ContentItem) => {
            const {
              targetUrl = "",
              imageUrl,
              imageId,
              imageWidth,
              imageHeight,
              imageTargetUrl,
              title,
              titleTargetUrl,
              description,
              descriptionTargetUrl,
              button,
              buttonTargetUrl
            } = cItem;
            contentDefaultUrlList.push(targetUrl || item.targetUrl);
            Array.prototype.push.apply(contentTexts, [title, description, button]);
            Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl, buttonTargetUrl]);
            contentImageList.push({
              imageUrl,
              id: imageId,
              width: imageWidth,
              height: imageHeight,
              targetUrl: imageTargetUrl,
            });
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentTexts,
            contentUrlList,
            contentImageList,
          };
        },
        () => {
          let contentDefaultUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          contentList?.forEach((cItem: ContentItem) => {
            const {
              imageUrl,
              imageId,
              imageWidth,
              imageHeight,
              imageTargetUrl
            } = cItem;
            contentDefaultUrlList.push(targetUrl);
            contentImageList.push({
              imageUrl,
              id: imageId,
              width: imageWidth,
              height: imageHeight,
              targetUrl: imageTargetUrl,
            });
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentImageList,
          };
        },
        () => {
          const contentDefaultUrlList: string[] = [targetUrl];
          let contentTexts: string[] = [];
          let contentUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          Array.prototype.push.apply(contentTexts, [title, description]);
          Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl]);
          subTitles.forEach((subTitle) => {
            const {
              title,
              titleTargetUrl,
              description,
              descriptionTargetUrl
            } = subTitle;
            Array.prototype.push.apply(contentTexts, [title, description]);
            Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl]);
          });
          Array.prototype.push.apply(contentTexts, [introduce, introDespcription]);
          Array.prototype.push.apply(contentUrlList, [introduceTargetUrl, introDespcriptionTargetUrl]);
          introButtons.forEach((button) => {
            const { title = "", titleTargetUrl = "" } = button;
            contentTexts.push(title);
            contentUrlList.push(titleTargetUrl);
          });
          contentImageList.push({
            imageUrl: introImageUrl,
            id: introImageId,
            width: introImageWidth,
            height: introImageHeight,
            targetUrl: introImageTargetUrl,
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentTexts,
            contentUrlList,
            contentImageList,
          };
        },
        () => {
          let contentDefaultUrlList: string[] = [];
          let contentTexts: string[] = [];
          let contentUrlList: string[] = [];
          let contentImageList: ImageParam[] = [];
          contentList?.forEach((cItem: ContentItem) => {
            const {
              targetUrl = "",
              imageUrl,
              imageId,
              imageWidth,
              imageHeight,
              imageTargetUrl,
              title,
              titleTargetUrl,
              description,
              descriptionTargetUrl,
            } = cItem;
            contentDefaultUrlList.push(targetUrl || item.targetUrl);
            Array.prototype.push.apply(contentTexts, [title, description]);
            Array.prototype.push.apply(contentUrlList, [titleTargetUrl, descriptionTargetUrl]);
            contentImageList.push({
              imageUrl,
              id: imageId,
              width: imageWidth,
              height: imageHeight,
              targetUrl: imageTargetUrl,
            });
          });
          return {
            tabType,
            tabLabel,
            targetUrl,
            contentDefaultUrlList,
            darkTheme,
            contentTexts,
            contentUrlList,
            contentImageList,
          };
        },
      ];
      const handleFunction = handleFunctions[tabType - 1];
      const itemData = handleFunction ? handleFunction() : {};
      return itemData;
    });
    return handleList;
  }

  get tabTypeList () {
    const listData = JSON.parse(this.tabList) as TabItems[] || [];
    const list = listData.map((item) => item.tabType);
    return list;
  }

  get campaignFormData () {
    return JSON.parse(this.fullScreenData || `{
      extraTemplateType: "",
      duration: "",
      targetLink: "",
      videoUrl: "",
      imageUrl: "",
    }`);
  }

  setAddDatas () {
    this.tabList = JSON.stringify(initialTabList);
    this.activeKey = 0;
    this.cardTypeList = JSON.stringify([]);
    this.fullScreenData = JSON.stringify({
      extraTemplateType: "", // 1: GIF首帧图，2: 图片
      duration: "", // 时长
      targetLink: "", // 跳转地址
      videoUrl: "", // 视频地址
      imageUrl: "", // 视频ID
    });
  }

  setEditDatas () {
    this.tabList = JSON.stringify(initialTabList);
    this.activeKey = 0;
    this.cardTypeList = JSON.stringify([]);
  }

  setTabList (list: string) {
    this.tabList = list;
  }

  setTabItem (index: number, key: string, value: any) {
    const newList = JSON.parse(this.tabList) as TabItems[];
    (newList[index] as any)[key] = value;
    this.tabList = JSON.stringify(newList);
  }

  setPriceAndUnit (index: number, contentIndex: number, price: number, unit: any) {
    const newList = JSON.parse(this.tabList) as TabItems[];
    const contentList = (newList[index] as any)?.contentList;
    if (contentList && contentList[contentIndex]) {
      (contentList[contentIndex] as any).description = `${cutZero(numberFormat(price, 2))}${unit}`;
    }
    this.tabList = JSON.stringify(newList);
  }

  setContentItem (index: number, contentIndex: number, key: string, value: any, contentKey = "contentList") {
    const newList = JSON.parse(this.tabList) as TabItems[];
    const contentList = (newList[index] as any)?.[contentKey];
    if (contentList && contentList[contentIndex]) {
      (contentList[contentIndex] as any)[key] = value;
    }
    this.tabList = JSON.stringify(newList);
  }

  setActiveKey (key: number) {
    this.activeKey = key;
  }

  setTypeList (list: CardItem[]) {
    this.cardTypeList = JSON.stringify(list);
  }

  setFullScreenDatas (data: any) {
    this.fullScreenData = JSON.stringify(data);
  }

  setFullScreenData (value: string | number, key: string) {
    const data = JSON.parse(this.fullScreenData);
    data[key] = value;
    this.fullScreenData = JSON.stringify(data);
  }
}
